export default class BusinessProcess {
  constructor(data) {
    // Map all keys to this
    for (const [key, value] of Object.entries(data))
      this[key] = value;
  }
}
